import { useMemo } from "react";
import { useGetGpUsersQuery } from "#graphql/supergraphHooks";

export interface GpUserOption {
  id: string;
  displayName: string;
  email: string | null;
}

interface UseGpUsersResult {
  users: GpUserOption[];
  loading: boolean;
  error: Error | null;
}

// BE returns gpUsersForArena.id as Int!; the modal's onConfirm callback contract
// is `assigneeId: string`, matching how the rest of the FE handles user ids.
// Convert at this boundary so consumers don't have to.
export function useGpUsers(arenaId: number | undefined): UseGpUsersResult {
  const { data, loading, error } = useGetGpUsersQuery({
    variables: { arenaId: arenaId ?? 0 },
    skip: !arenaId,
  });

  const users = useMemo<GpUserOption[]>(
    () =>
      (data?.gpUsersForArena ?? []).map((u) => ({
        id: String(u.id),
        displayName: u.displayName,
        email: u.email ?? null,
      })),
    [data],
  );

  return { users, loading, error: error ?? null };
}
